module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-SemiBold-689a49a3cea80f39b5b03146b66f4b02.ttf";